module.exports = __webpack_public_path__ + "img/Logo.0741cfb0.svg";